























































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import UiDatePicker, { UiDatePickerDate } from '@/components/ui/ui-date-picker.vue';
import moment from 'moment';
import PickerMixin from '@/views/reports/mixins/picker-mixin';

const getTimeFormatted = num => num < 10 ? `0${num}` : num
const TIMES = Array(25).fill(null).map((_, i) => `${getTimeFormatted(i)}:00`)

const splitTime = time => {
  const [t1, t2]	= time.split(':')

  const offset = +t2 <= 30 ? 0 : 1
  return +t1 + offset
}

@Component
export default class UiPeriodPicker extends PickerMixin {
  @Prop()
  text: string;
  
  @Prop()
  dateValue: string;

  @Prop()
  columns: number;

  @Prop()
  value:TimeRange;

  @Prop({default: 'YYYY-MM-DD HH:mm:ss'})
  format: string;

  @Prop()
  timeInTitle: string | boolean;

  @Prop()
  menuContentClass: string;

  @Emit('input')
  onInput(value: TimeRange) {}

  @Emit('apply')
  onApply(event: any) {}

  @Emit('reset')
  onReset(event: any) {}

  @Prop({ default: true })
  showTimezone: boolean;

  range: TimeRange = {
    from:'',
    to:'',
    timezone: this.$store.state.user.defaultTimezone
  };
  
  get pickerColumns(){
    return this.columns || (this.isFullWidth ? 2 : 1)
  } 
  
  drag: UiDatePickerDate = null;

  @Watch('value', { immediate: true })
  onValueChanged(value: TimeRange) {
    this.range = value;
  }
  
  @Watch('range.timezone', { immediate: true })
  onTimezoneChanged(value,oldValue) {
    if(oldValue && value && (this.dateValue==='last24hours' || this.dateValue==='last48hours')){
      this.$set(this.range, 'from', this.getRangeValueColection({timezone:value})[this.dateValue].from);
      this.$set(this.range, 'to', this.getRangeValueColection({timezone:value})[this.dateValue].to);
    }
    this.$emit('input', this.range);
  }

  get start() {
    return TIMES.slice(0, TIMES.length - 1)
  }

  get end() {
    const startTime = splitTime(this.timeFrom)
    if (this.isSameDay) {
      return TIMES.slice(1).filter(time => splitTime(time) > startTime)
    }
    return TIMES.slice(1, TIMES.length)
  }

  get pMenuContentClass() {
    let result: string[] = [ 'ui-period-picker__menu-wrapper' ];

    if(this.menuContentClass) {
      result.push(this.menuContentClass);
    }

    return result.join(' ');
  }

  get isFullWidth() {
    return this.$vuetify.breakpoint.mdAndUp;
  }

  get isTimeInTitle() {
    return this.timeInTitle === '' || this.timeInTitle;
  }

  get defaultText() {
    return this.isTimeInTitle 
      ? `${this.dateFrom} ${this.timeFrom} – ${this.dateTo} ${this.timeTo}`
      : `${this.dateFrom} – ${this.dateTo}`;
  }

  get pText() {
     return this.text || this.defaultText;
  }

  get pRange(): UiDatePickerDate {
    return {
      start: moment(this.range.from).toDate(),
      end: moment(this.range.to).toDate(),
      timezone:this.range.timezone
    };
  }
  
  set pRange(value: UiDatePickerDate) {
    const from = moment(this.range.from);
    const to = moment(this.range.to); 

    this.onInput({
      ...this.range,
      from:moment(value.start)
        .hours(from.hours())
        .minutes(from.minutes())
        .seconds(from.seconds())
        .format(this.format),
      to:moment(value.end)
      .hours(to.hours())
      .minutes(to.minutes())
      .seconds(to.seconds())
      .format(this.format)
    });
  }

  handleDrag(value: UiDatePickerDate) {
    this.drag = null

    if(value) {
      this.drag = value;
    } else if(this.drag){
      const range = {
        to:moment(this.drag.start)
          .hours(0)
          .minutes(0)
          .seconds(0)
          .format(this.format),
        from:moment(this.drag.end)
          .hours(23)
          .minutes(59)
          .seconds(59)
          .format(this.format)
        };

      this.onInput({
        ...this.range,
        ...range
      });
      
      this.drag = null;
    }

    if (this.isSameDay && this.isStartAfterEndTime ) {
        this.timeTo = '24:00'
    }

  }

  get dateFrom() {
    return moment(this.range.from).format('DD MMM YYYY');
  }

  get dateTo() {
    return moment(this.range.to).format('DD MMM YYYY');
  }

  get timeFrom() {
    return moment(this.range.from).format('HH:mm');
  }

  get isStartAfterEndTime() {
    return moment(this.range.from).isAfter(moment(this.range.to))
  }

  get isSameDay() {
    return moment(this.range.from).isSame(this.range.to, 'day')
  }

  set timeFrom(value: string) {
    const date = this.getDateWithUpdatedTime(this.range.from, value);
    this.$set(this.range, 'from', `${date}:00`);

    if (this.isStartAfterEndTime) {
      this.timeTo = '24:00'
    }
  }

  get timeTo() {
    const time = moment(this.range.to).add(1, 'seconds').format('HH')

    return time === '00' ? '24:00' : `${time}:00`
  }

  set timeTo(value: string) {
    const date = moment(this.getDateWithUpdatedTime(this.range.to, value))
        .subtract(1, 'seconds')
        .format('YYYY-MM-DD HH:mm:ss')

    this.$set(this.range, 'to', date);
  }

  getDateWithUpdatedTime(date: any, time: string)   {
    const dateWithoutTime = moment(date).format('YYYY-MM-DD');
    return `${dateWithoutTime} ${time}`; 
  }

  toggleMenu() {
    const picker = this.$refs.picker as any;
    picker.toggleMenu(false);
  }

  redrawMenu() {
    const picker = this.$refs.picker as any;
    picker?.redrawMenu?.();
  }

  adjustPageRange() {
    const datePicker = this.$refs.datePicker as UiDatePicker;
    datePicker.adjustPageRange();
  }
}
